var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st1{fill:url(#SVGID_1_);}\r\n\t.st2{fill:url(#SVGID_2_);}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 124.709,
    y1: 500,
    x2: 875.291,
    y2: 500
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#649693"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1467,
    style: {
      stopColor: "#63A3A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3932,
    style: {
      stopColor: "#62B3B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6634,
    style: {
      stopColor: "#61BCBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#61BFBF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M146.32,404.38v-17.49h48.84c5.83,0,10.45-1.57,13.86-4.7c3.41-3.14,5.12-7.51,5.12-13.12 c0-5.83-1.71-10.28-5.12-13.37c-3.41-3.08-8.03-4.62-13.86-4.62h-46.2v87.94h-21.95V332.28h66.17c5.94,0,11.52,0.72,16.75,2.15 c5.22,1.43,9.79,3.63,13.7,6.6c3.9,2.97,6.96,6.76,9.16,11.38c2.2,4.62,3.3,10.18,3.3,16.67c0,6.38-1.1,11.83-3.3,16.33 c-2.2,4.51-5.25,8.17-9.16,10.97c-3.91,2.8-8.47,4.84-13.7,6.1c-5.23,1.27-10.81,1.9-16.75,1.9H146.32z M316.94,441.18 c-14.19,0-26.32-2.23-36.38-6.68c-10.07-4.46-17.77-10.81-23.1-19.06c-5.34-8.25-8-18.15-8-29.7c0-11.66,2.67-21.62,8-29.87 c5.33-8.25,13.04-14.6,23.1-19.06c10.06-4.46,22.19-6.68,36.38-6.68c14.3,0,26.45,2.23,36.46,6.68 c10.01,4.45,17.68,10.81,23.02,19.06c5.33,8.25,8,18.21,8,29.87c0,11.55-2.67,21.45-8,29.7c-5.34,8.25-13.01,14.6-23.02,19.06 C343.39,438.95,331.23,441.18,316.94,441.18z M316.94,422.2c8.8,0,16.53-1.32,23.18-3.96c6.65-2.64,11.88-6.65,15.68-12.04 c3.79-5.39,5.69-12.21,5.69-20.46s-1.9-15.07-5.69-20.46c-3.79-5.39-9.02-9.43-15.68-12.13c-6.66-2.69-14.38-4.04-23.18-4.04 c-8.69,0-16.45,1.35-23.27,4.04c-6.82,2.7-12.16,6.74-16,12.13c-3.85,5.39-5.78,12.21-5.78,20.46s1.92,15.07,5.78,20.46 c3.85,5.39,9.18,9.4,16,12.04C300.49,420.88,308.24,422.2,316.94,422.2z M405.87,439.03V332.28h72.43c8.25,0,15.43,1.13,21.53,3.38 c6.1,2.26,10.86,5.77,14.27,10.56c3.41,4.79,5.11,10.92,5.11,18.4c0,5.06-0.88,9.35-2.64,12.87c-1.76,3.52-4.21,6.38-7.34,8.58 c-3.13,2.2-6.74,3.88-10.81,5.03c-4.07,1.16-8.41,1.9-13.03,2.23l-2.31-1.32c7.7,0.11,14.03,0.74,18.98,1.9 c4.95,1.15,8.66,3.25,11.14,6.27c2.48,3.03,3.71,7.51,3.71,13.45v25.41h-21.95v-23.92c0-4.07-0.72-7.23-2.14-9.49 c-1.43-2.25-3.99-3.82-7.67-4.7c-3.69-0.88-8.99-1.32-15.92-1.32h-41.42v39.44H405.87z M427.81,382.44h50.49 c6.16,0,10.86-1.48,14.11-4.45c3.24-2.97,4.87-6.98,4.87-12.05c0-4.84-1.62-8.52-4.87-11.05c-3.25-2.53-7.95-3.79-14.11-3.79h-50.49 V382.44z M532.75,332.28h112.53v18.31H532.75V332.28z M578.13,348.28h21.95v90.75h-21.95V348.28z M639.21,439.03l50.16-106.75h23.76 l50.66,106.75h-23.92l-43.89-96.19h10.56l-43.56,96.19H639.21z M665.77,415.77v-18.31h70.62v18.31H665.77z M804.34,332.28v88.44 h70.95v18.31H782.4V332.28H804.34z M317.06,489.03l-77.82,121.38v55.9h-36.72v-55.9l-77.82-121.38h42.2l65.49,106.04h-21.92 l64.39-106.04H317.06z M429.12,669.87c-23.56,0-43.7-3.7-60.42-11.1s-29.5-17.95-38.36-31.65c-8.86-13.7-13.29-30.14-13.29-49.32 c0-19.36,4.43-35.89,13.29-49.59c8.86-13.7,21.65-24.25,38.36-31.65s36.85-11.1,60.42-11.1c23.74,0,43.93,3.7,60.55,11.1 c16.62,7.4,29.36,17.95,38.22,31.65c8.86,13.7,13.29,30.23,13.29,49.59c0,19.18-4.43,35.62-13.29,49.32 c-8.86,13.7-21.6,24.25-38.22,31.65C473.05,666.17,452.87,669.87,429.12,669.87z M429.12,638.36c14.61,0,27.44-2.19,38.5-6.58 c11.05-4.38,19.73-11.05,26.03-20c6.3-8.95,9.45-20.28,9.45-33.98s-3.15-25.02-9.45-33.98c-6.3-8.95-14.98-15.66-26.03-20.14 c-11.05-4.47-23.88-6.71-38.5-6.71c-14.43,0-27.31,2.24-38.63,6.71c-11.33,4.48-20.19,11.19-26.58,20.14 c-6.4,8.95-9.59,20.28-9.59,33.98s3.19,25.03,9.59,33.98c6.39,8.95,15.25,15.62,26.58,20C401.81,636.17,414.69,638.36,429.12,638.36 z M682.3,669.87c-16.44,0-31.28-1.92-44.53-5.75c-13.25-3.84-24.66-9.59-34.25-17.26s-16.95-17.17-22.06-28.5 c-5.12-11.32-7.67-24.39-7.67-39.18c0-14.98,2.69-28.27,8.08-39.87c5.39-11.6,13.06-21.41,23.02-29.46 c9.95-8.04,21.83-14.11,35.62-18.22c13.79-4.11,29.09-6.17,45.89-6.17c19.91,0,37.08,2.79,51.51,8.36 c14.43,5.57,25.8,13.38,34.11,23.43c8.31,10.05,13.02,22.01,14.11,35.89h-35.07c-2.38-7.3-6.26-13.65-11.64-19.04 c-5.39-5.39-12.47-9.59-21.24-12.6s-19.36-4.52-31.78-4.52c-15.89,0-29.46,2.56-40.69,7.67c-11.23,5.12-19.78,12.33-25.62,21.65 c-5.85,9.32-8.77,20.28-8.77,32.88c0,12.24,2.56,22.79,7.67,31.65c5.11,8.86,13.01,15.67,23.7,20.41 c10.69,4.75,24.34,7.12,40.96,7.12c12.78,0,24.06-1.69,33.84-5.07c9.77-3.38,17.95-7.95,24.52-13.7 c6.58-5.75,11.23-12.19,13.97-19.32l14.25-5.21c-2.38,23.56-11.28,41.92-26.72,55.07C728.1,663.29,707.69,669.87,682.3,669.87z  M760.94,666.31c0-5.66,0.36-12.19,1.1-19.59c0.73-7.4,1.64-14.89,2.74-22.47c1.1-7.58,2.1-14.56,3.01-20.96h-81.1V580h105.76v86.31 H760.94z M838.85,489.03h36.44v177.28h-36.44V489.03z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.00008138021,
    y1: 500,
    x2: 999.9998,
    y2: 500
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#649693"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#649895"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.033,
    style: {
      stopColor: "#63ABA9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0709,
    style: {
      stopColor: "#61BAB9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#61BFBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1221,
    style: {
      stopColor: "#69BFBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2568,
    style: {
      stopColor: "#97BCA9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3859,
    style: {
      stopColor: "#BBBA9A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5062,
    style: {
      stopColor: "#D5B88F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6144,
    style: {
      stopColor: "#E5B788"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#EAB786"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7013,
    style: {
      stopColor: "#EAB786"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#EAB786"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.807,
    style: {
      stopColor: "#EAB19E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8776,
    style: {
      stopColor: "#E9ABB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9436,
    style: {
      stopColor: "#E9A7C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9A6C9"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M500,25c64.14,0,126.34,12.56,184.88,37.32c56.56,23.92,107.36,58.18,150.99,101.81 c43.63,43.63,77.88,94.43,101.81,150.99C962.44,373.66,975,435.86,975,500s-12.56,126.34-37.32,184.88 c-23.92,56.56-58.17,107.36-101.81,150.99c-43.63,43.63-94.43,77.88-150.99,101.81C626.34,962.44,564.14,975,500,975 c-64.14,0-126.34-12.56-184.88-37.32c-56.56-23.92-107.36-58.18-150.99-101.81c-43.63-43.63-77.88-94.43-101.81-150.99 C37.56,626.34,25,564.14,25,500s12.56-126.34,37.32-184.88c23.92-56.56,58.18-107.36,101.81-150.99 c43.63-43.63,94.43-77.88,150.99-101.81C373.66,37.56,435.86,25,500,25 M500,0C223.86,0,0,223.86,0,500s223.86,500,500,500 c276.14,0,500-223.86,500-500S776.14,0,500,0L500,0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e9d72496cd3a015109cd3b6d26662848.svg";
export { ForwardRef as ReactComponent };